import Vue from 'vue'
import App from './App.vue'

import iView from 'iview'; // 导入组件库
import 'iview/dist/styles/iview.css'; // 导入样式
Vue.use(iView);

import router from './router'
import util from './util/util.js'
// import './assets/js/sosh.min.js'

// 引入预览图片
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
		title: false,
		// view: function (a,b,c) {
		// 	Viewer.setDefaults({
		// 		title: function () {return a.detail.originalImage.dataset.name}
		// 	})
		// }
  }
})



// ES6 分享插件
import vshare from 'vshare'
Vue.use(vshare)

// 登录注册rsa加密
import JSEncrypt from 'jsencrypt';
Vue.prototype.JSEncrypt = JSEncrypt;

import 'vue-social-share/dist/client.css';
import Share from 'vue-social-share'
Vue.use(Share)
// Vue.use(VideoPlayer)

Vue.prototype.util = util
// 引入全局样式
import './assets/css/iconfont.css'
import './assets/css/common.css'

import Meta from 'vue-meta';
// 使用vue-meta
Vue.use(Meta);

// 引入js文件
import './assets/js/jquery.min.js'
import './assets/js/bootstrap.min.js'
import './assets/js/bolang.js'
import './assets/js/carousel_focus.min.js'
import './assets/js/sjz.js'
// import './assets/js/journal/jquery.js'
// import './assets/js/journal/onload.js'
// import './assets/js/journal/turn.js'
// import './assets/js/main.min.js'



import { get, post, get_res, post_res, get_video, delete_api, put, addDevote,post_res_bold } from './http'
Vue.prototype.get=get
Vue.prototype.post=post
Vue.prototype.delete_api=delete_api
Vue.prototype.get_res=get_res
Vue.prototype.post_res=post_res
Vue.prototype.get_video=get_video
Vue.prototype.put=put
Vue.prototype.addDevote=addDevote
Vue.prototype.post_res_bold=post_res_bold
Vue.config.productionTip = false
new Vue({
	router,
  render: h => h(App),
	  mounted () {
	    // document.dispatchEvent(new Event('render-event'))
	  }
}).$mount('#app')
